import type { ActionReducer } from '@ngrx/store';
import { inject } from '@angular/core';
import { PlatformService } from '@core/platform';
import { localStorageSync } from 'ngrx-store-localstorage';
import { WINDOW } from '@innogy/utils-dom';

export function conversationalChatMetaReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  const platformService = inject(PlatformService);
  const window = inject(WINDOW);

  return localStorageSync({
    keys: ['conversationalChatSessionId'],
    rehydrate: true,
    storage: platformService.isClient() ? window.localStorage : undefined,
    removeOnUndefined: true,
    storageKeySerializer: (key) => `conversationalChat:${key}`,
  })(reducer);
}
